import React from "react";
import { FontAwesomeIcon as FontAwesomeIconInternal} from "@fortawesome/react-fontawesome";
import _ from "lodash";

export class FontAwesomeIcon extends React.PureComponent {

	render() {
		if (_.isString(this.props.icon)) {
			return <FontAwesomeIconInternal {...this.props} icon={["far", this.props.icon]}>{this.props.children}</FontAwesomeIconInternal>;		
		} else {
			return <FontAwesomeIconInternal {...this.props} icon={this.props.icon}>{this.props.children}</FontAwesomeIconInternal>;
		}
	}
}
